import { useEffect, useState } from 'react'
import { apiFetch } from '../../lib/api.js'

function ProgressionBadge({ value }) {
  if (value === 0) return <span className="text-white/30 text-xs">= mois précédent</span>
  const pos = value > 0
  return (
    <span className={`text-xs font-semibold ${pos ? 'text-green-400' : 'text-red-400'}`}>
      {pos ? '▲' : '▼'} {Math.abs(value)}% vs mois préc.
    </span>
  )
}

function IndicateurCard({ emoji, label, mois, total, progression }) {
  return (
    <div className="bg-gray-800/50 border border-white/10 rounded-2xl p-5 flex flex-col gap-2">
      <div className="flex items-center gap-2 text-white/50 text-sm font-medium">
        <span className="text-xl">{emoji}</span>
        <span>{label}</span>
      </div>
      <div className="text-5xl font-bold text-white tabular-nums leading-none py-1">
        {mois.toLocaleString('fr-FR')}
      </div>
      <div className="flex flex-col gap-1 mt-1">
        <ProgressionBadge value={progression} />
        <span className="text-white/30 text-xs">
          Total cumulé : {total.toLocaleString('fr-FR')}
        </span>
      </div>
    </div>
  )
}

export default function Dashboard() {
  const [data, setData]       = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState(null)

  useEffect(() => {
    apiFetch('/api/admin/dashboard')
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false))
  }, [])

  const moisLabel = new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })

  return (
    <div className="max-w-4xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Tableau de bord</h1>
        <p className="text-white/40 text-sm mt-1 capitalize">Activité — {moisLabel}</p>
      </div>

      {loading && (
        <div className="text-white/40 text-sm">Chargement…</div>
      )}

      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-3 text-red-400 text-sm">
          Erreur : {error}
        </div>
      )}

      {data && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.indicateurs.map(ind => (
            <IndicateurCard key={ind.label} {...ind} />
          ))}
        </div>
      )}
    </div>
  )
}
